import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-toggle',
  template: `
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="visible ? 'Hide password' : 'Show password'"
      (click)="toggleVisibility()"
    >
      <mat-icon [svgIcon]="visible ? 'visibility_off' : 'visibility'"></mat-icon>
    </button>
  `,
  styleUrls: ['./password-toggle.component.scss']
})
export class PasswordToggleComponent {
  @Input() inputElement: HTMLInputElement;
  visible = false;

  toggleVisibility(): void {
    this.visible = !this.visible;
    if (this.inputElement) {
      this.inputElement.type = this.visible ? 'text' : 'password';
    }
  }
} 